module.exports = __webpack_public_path__ + "assets1735077819010/img/logo1.bcf77f3c.png";